export interface ModifyAppointmentWsV2Params {
  code: string;
  partnerBranch?: {
    oldID: string;
    newID: string;
  };
  replaceSlot: {
    oldSlotID: string;
    newSlotID: string;
  };
  folderRef: string;
  comments?: string;
}

export interface ModifyAppointmentWsV2ResponseSuccess {
  status: 'OK';
  response: {
    code: '200';
    message: 'Replaced';
  };
  data: {
    folderID: string;
    newSlotID: string;
  };
}

export interface ModifyAppointmentWsV2ResponseError {
  status: 'ERROR';
  response: {
    code: string;
    message: string;
  };
}
